import { useState } from "react";
import { Slide,Fade } from "react-awesome-reveal";


import { HiArrowsRightLeft, HiOutlineArrowsUpDown } from "react-icons/hi2";







function Rules(){
    const [french,setFrench] = useState(false);


function handleFrench(){
    setFrench(true)
}

function handleEnglish(){
    setFrench(false)
}





return(
<>
   {french === false?
    <Fade cascade damping={0.1}><h3 className="fst-italic fw-bold fs-4 text-warning">Game instructions <button onClick={handleFrench} className="btn btn-outline-warning fst-italic fw-bold btn-md rounded-pill">Consignes de jeu</button></h3>

    
    <p className="fst-italic fw-bold fs-6 text-white"> Welcome to Pearl play game. Its a two players game.
    There are two separate tables of 10 Pearls each.</p>
    <p className="fst-italic fw-bold fs-6 text-white"> Players can take 1 or 2 or 3 or 4 pearls as they wish.
        But if player-1 took 2 pearls, player 2 must take 1 or 3 or 4 pearls.</p>

    
    <p className="fst-italic fw-bold fs-5 text-warning">The player who left to remove the final ball from the board loses!</p>

    
    <h4 className="fst-italic fw-bold fs-4 text-warning">Now Your turn !</h4>
    
    
    <p className="fst-italic fw-bold fs-6 text-white">To play the game, you must register your first or last name!</p>
    
     </Fade> : 
     //if the condition is false
      <Fade cascade damping={0.1}><h3 className="fst-italic fw-bold fs-4 text-warning">Consignes de jeu   <button onClick={handleEnglish} className="btn btn-outline-warning fst-italic fw-bold btn-md rounded-pill">Game instructions</button></h3>

    
<p className="fst-italic fw-bold fs-6 text-white">Bienvenue dans le jeu Pearl Play. C'est un jeu à deux joueurs.
     Il y a deux tableaux séparés de 10 perles chacun.</p>
<p className="fst-italic fw-bold fs-6 text-white"> Les joueurs peuvent prendre 1 ou 2 ou 3 ou 4 perles comme ils le souhaitent.</p>
<p className="fst-italic fw-bold fs-6 text-white"> Mais si le joueur 1 (Player-1) a pris 2 perles, le joueur 2 (Player-2) doit prendre 1 ou 3 ou 4 perles.</p>


<p className="fst-italic fw-bold fs-5 text-warning">Le joueur qui est parti pour retirer la dernière boule du plateau a perdu !</p>


<h4 className="fst-italic fw-bold fs-4 text-warning">Maintenant à votre tour !</h4>


<p className="fst-italic fw-bold fs-6 text-white">Pour jouer au jeu, vous devez enregistrer votre nom ou prénom !</p>

 </Fade>}

     </>


   
)

}
export default Rules;